import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from './ErrorBoundary';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary name="@aether/llm-dashboard">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
